export enum ServicePaymentMethodTypes {
  CreditCard = 'scheme',
  RatePayInvoice = 'openInvoice',
  RatePayDirectDebit = 'directDebit',
  Paypal = 'paypal',
  DirectEbanking = 'directEbanking',
  IDeal = 'ideal',
  PayPal_ins_FR = 'paypal_ins_fr',
  PayPal_ins_ES = 'paypal_ins_es',
  PayPal_ins_IT = 'paypal_ins_it',
  SepaDebitDirect = 'sepadirectdebit',
  Billie = 'klarna_b2b',
  MetroInvoice = 'metro_invoice',
  PayByBank = 'paybybank',
}
export type PaypalServicePaymentMethods =
  | ServicePaymentMethodTypes.PayPal_ins_FR
  | ServicePaymentMethodTypes.Paypal
  | ServicePaymentMethodTypes.PayPal_ins_IT
  | ServicePaymentMethodTypes.PayPal_ins_ES;
